/* Beautify premium header behavior:
   - adds .ck-scrolled to <body> past a scroll threshold (drives the compact
     frosted header state in ck-premium.css)
   - tags the configured nav item as a brick "pill" (Theme settings →
     Beautify premium (ck) → Pill nav item) */
(function () {
  if (window.ckPremiumLoaded) return;
  window.ckPremiumLoaded = true;

  /* Compact/frosted state with hysteresis so it never flickers at the edge */
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var y = window.scrollY;
      if (y > 80) {
        document.body.classList.add('ck-scrolled');
      } else if (y < 40) {
        document.body.classList.remove('ck-scrolled');
      }
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* Pill nav item: OFF unless a menu-item name is typed in Theme settings →
     Beautify premium (ck) → Pill nav item. (Auto-pilling the last item was
     rejected by the client — blank now means no pill.) */
  function applyPill() {
    var label = (document.body.getAttribute('data-ck-pill') || '').trim().toLowerCase();
    if (!label || label === 'none') {
      Array.prototype.forEach.call(document.querySelectorAll('.ck-pill'), function (el) {
        el.classList.remove('ck-pill');
      });
      return;
    }

    var topItems = document.querySelectorAll(
      '.header__inline-menu > ul > li > a.header__menu-item, .header__inline-menu > ul > li > header-menu > details > summary.header__menu-item, .header__inline-menu > ul > li > details > summary.header__menu-item'
    );
    if (!topItems.length) return;

    var target = null;
    Array.prototype.forEach.call(topItems, function (el) {
      if ((el.textContent || '').trim().toLowerCase() === label) target = el;
    });
    if (!target) return;
    var targetText = (target.textContent || '').trim().toLowerCase();

    var all = document.querySelectorAll('.header__menu-item, .menu-drawer__menu-item');
    Array.prototype.forEach.call(all, function (el) {
      var isTop = el === target;
      var isDrawerTwin =
        el.classList.contains('menu-drawer__menu-item') &&
        (el.textContent || '').trim().toLowerCase() === targetText;
      el.classList.toggle('ck-pill', isTop || isDrawerTwin);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyPill);
  } else {
    applyPill();
  }

  document.addEventListener('shopify:section:load', applyPill);

  /* Tap the dimmed page to close the menu drawer (cart-drawer behavior) */
  document.addEventListener('click', function (e) {
    var container = document.querySelector('.menu-drawer-container[open]');
    if (!container) return;
    if (e.target.closest && (e.target.closest('.menu-drawer') || e.target.closest('summary'))) return;
    var summary = container.querySelector('summary');
    var headerDrawer = container.closest('header-drawer');
    if (headerDrawer && typeof headerDrawer.closeMenuDrawer === 'function' && summary) {
      headerDrawer.closeMenuDrawer(e, summary);
    } else if (summary) {
      summary.click();
    }
    // Safety net: if Dawn's close animation gets interrupted, force the
    // drawer fully closed so no stuck state can linger.
    setTimeout(function () {
      if (!container.classList.contains('menu-opening') && container.hasAttribute('open')) {
        container.removeAttribute('open');
      }
    }, 600);
  });

  /* Watch EVERY close path (hamburger toggle, link tap, Escape, tap-outside):
     once .menu-opening is gone, give Dawn's close animation a beat, then force
     the drawer's [open] attribute and body scroll-lock classes clear so the
     dim overlay can never stay stuck. */
  function armDrawerWatchdog() {
    var container = document.querySelector('.menu-drawer-container');
    if (!container || container.dataset.ckWatchdog === 'true' || !('MutationObserver' in window)) return;
    container.dataset.ckWatchdog = 'true';

    /* body.ck-menu-open drives the dim overlay (see ck-premium.css) —
       mirroring .menu-opening keeps it a binary that can never stick */
    function syncOverlay() {
      var opening = container.classList.contains('menu-opening');
      document.body.classList.toggle('ck-menu-open', opening);
      /* Dawn's own scrim + assistive state key off aria-expanded, and some
         close paths leave it stuck "true" — force it honest on close */
      if (!opening) {
        var summary = container.querySelector('summary.header__icon--menu');
        if (summary && summary.getAttribute('aria-expanded') === 'true') {
          summary.setAttribute('aria-expanded', 'false');
        }
      }
    }
    syncOverlay();

    new MutationObserver(function () {
      syncOverlay();
      if (container.classList.contains('menu-opening')) return;
      setTimeout(function () {
        syncOverlay();
        if (container.classList.contains('menu-opening')) return;
        if (container.hasAttribute('open')) container.removeAttribute('open');
        /* only release the lock the HEADER drawer owns — the facets drawer
           uses overflow-hidden-mobile and must keep its own lock */
        var headerDrawer = container.closest('header-drawer');
        var breakpoint = headerDrawer && headerDrawer.dataset ? headerDrawer.dataset.breakpoint : '';
        document.body.classList.remove('overflow-hidden-' + (breakpoint || 'tablet'));
      }, 500);
    }).observe(container, { attributes: true, attributeFilter: ['class', 'open'] });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', armDrawerWatchdog);
  } else {
    armDrawerWatchdog();
  }
  document.addEventListener('shopify:section:load', armDrawerWatchdog);
})();

/* ---------- Lazy-image rescue ----------
   iOS Low Data / Low Power Mode can skip loading="lazy" fetches entirely,
   leaving blank boxes on one device while every other browser looks fine.
   Rescue passes: any lazy image near the viewport that never loaded gets
   flipped to eager and re-kicked. */
(function () {
  'use strict';
  function rescue() {
    var margin = window.innerHeight * 2;
    Array.prototype.forEach.call(
      document.querySelectorAll('img[loading="lazy"]'),
      function (img) {
        if (img.complete && img.naturalWidth > 0) return;
        var r = img.getBoundingClientRect();
        if (r.bottom < -margin || r.top > window.innerHeight + margin) return;
        img.loading = 'eager';
        // reassigning src forces engines that skipped the fetch to retry
        var s = img.src;
        if (s) img.src = s;
      }
    );
  }
  function arm() {
    setTimeout(rescue, 1500);
    setTimeout(rescue, 4000);
    var t = null;
    window.addEventListener(
      'scroll',
      function () {
        if (t) return;
        t = setTimeout(function () { t = null; rescue(); }, 600);
      },
      { passive: true }
    );
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm);
  } else {
    arm();
  }
})();

/* ---------- Free-shipping bar live updater ----------
   Dawn re-renders drawer regions inconsistently across add/quantity/remove
   paths; instead of relying on that, recompute the bar from /cart.js on
   every cart mutation. Writes are skipped when values are unchanged so the
   MutationObservers can't feed back into themselves. */
(function () {
  'use strict';
  function fmt(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  function update() {
    var bars = document.querySelectorAll('[data-ck-shipbar]');
    if (!bars.length) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        Array.prototype.forEach.call(bars, function (bar) {
          var threshold = parseInt(bar.dataset.threshold, 10);
          if (!threshold) return;
          var pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
          var remaining = Math.max(0, threshold - cart.total_price);
          var fill = bar.querySelector('.ck-shipbar__fill');
          var done = bar.querySelector('[data-ck-shipbar-done]');
          var prog = bar.querySelector('[data-ck-shipbar-progress]');
          var amt = bar.querySelector('[data-ck-shipbar-amt]');
          if (fill && fill.style.width !== pct + '%') fill.style.width = pct + '%';
          if (amt && amt.textContent !== fmt(remaining)) amt.textContent = fmt(remaining);
          if (done && done.hidden !== (remaining > 0)) done.hidden = remaining > 0;
          if (prog && prog.hidden !== (remaining <= 0)) prog.hidden = remaining <= 0;
        });
      })
      .catch(function () {});
  }
  var t = null;
  function schedule() {
    clearTimeout(t);
    t = setTimeout(update, 150);
  }
  function arm() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && bubble.parentElement) {
      new MutationObserver(schedule).observe(bubble.parentElement, { childList: true, subtree: true });
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true });
    }
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, schedule); } catch (e) { /* noop */ }
    }
    schedule();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm);
  } else {
    arm();
  }
})();

/* ---------- Minus-at-1 removes the item ----------
   Dawn clamps the cart quantity input at its minimum (1) and shows a
   quantity-rules notice instead. Shoppers expect minus on a single item
   to remove it, same as the trash button — intercept in the capture
   phase (before quantity-input's own button handler) and reroute. */
(function () {
  'use strict';
  document.addEventListener(
    'click',
    function (e) {
      if (!e.target || !e.target.closest) return;
      var minus = e.target.closest('button[name="minus"]');
      if (!minus) return;
      if (!minus.closest('cart-drawer-items, cart-items')) return;
      var wrap = minus.closest('quantity-input');
      var input = wrap && wrap.querySelector('.quantity__input');
      if (!input || parseInt(input.value, 10) > 1) return;
      var row = minus.closest('.cart-item');
      var remove = row && row.querySelector('cart-remove-button button, cart-remove-button a');
      if (!remove) return;
      e.preventDefault();
      e.stopPropagation();
      remove.click();
    },
    true
  );
})();
